module.exports = __webpack_public_path__ + "img/standing_kiosk.9a72b9e4.gif";